export enum RequestType {
  GET,
  POST,
  DELETE,
  UPDATE,
}
